import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {IssuedState, Invoices, GetInvoiceDocumentRequest} from './types'
import {updateAll, updateObject} from '@/store/utils'

const initState: IssuedState = {
  invoices: [],
  count: 0,
  nextOffset: 0,
  invoiceDocumentData: '',

  invoice: {
    id: '',
    status: '',
    errorCode: '',
    isForcedPayment: false,
    confirmNumber: '',
    mainItemName: '',
    totalAmount: 0,
    totalSupply: 0,
    totalTax: 0,
    isTaxFree: false,
    writeDate: '',
    issueDate: '',
    sendDate: '',
    issueType: '',
    purposeType: '청구',
    cash: 0,
    checkBill: 0,
    credit: 0,
    note: 0,
    remark: '',
    bizName: '',
    bizOwnerName: '',
    bizAddress: '',
    bizClass: '',
    bizType: '',
    bizEmail: '',
    bizNumber: '',
    bizTaxNumber: '',
    clientId:'',
    clientName: '',
    clientOwnerName: '',
    clientAddress: '',
    clientBizClass: '',
    clientBizType: '',
    clientType: '',
    clientEmail: '',
    clientSubEmail: '',
    clientBizNumber: '',
    clientTaxNumber: '',
    items: []
  }
}

const module: ModuleFc<IssuedState> = (ctx) => {
  return {
    namespaced: true,
    state: cloneDeep(initState),
    mutations: {
      updateAll(state, payload: {list: Invoices[], offset, count}) {
        updateAll(state.invoices, payload.list)
        state.nextOffset = payload.offset
        state.count = payload.count
      },
      update(state, payload: IssuedState) {
        updateObject(state, payload)
      },
      remove(state, payload: string) {
        state[payload] = cloneDeep(initState[payload])
      },
      clear(state) {
        updateObject(state, cloneDeep(initState))
      },
    },
    actions: {
      async getIssuedInvoices({commit, rootState, state}, payload = {}) {
        const kind = 'invoice_issue'
        const bizId = rootState.biz.id
        const status = []
        const limit = 10
        const offset = Number(state.nextOffset)
        const {client} = payload
        const result = await ctx.$axios({
          url: '/invoices/issued',
          data: {
            bizId,
          },
          params: {
            kind,
            status,
            limit,
            offset,
            client,
          }
        })
        commit('updateAll', {
          list: result.data.results,
          offset: result.data.nextOffset,
          count: result.data.count
        })
      },
      async getInvoice({commit, rootState}, payload = {}) {
        const result = await ctx.$axios({
          url: '/invoices/issued/$id',
          method: 'get',
          params: {
            bizId: rootState.biz.id,
            id: payload.id,
          },
        })
        commit('update', {invoice: result.data})
        return result.data
      },
      async getReview({rootState}, payload: GetInvoiceDocumentRequest) {
        const {data} = await ctx.$axios({
          url: '/invoice-review',
          params: {
            bizId: rootState.biz.id,
            invoiceId: payload.invoiceId,
            type: payload.type,
          },
          data: payload,
          method: 'post',
        })
        return data
      },
      async getInvoiceFile({rootState}, payload: {invoiceId: string}) {
        const {data} = await ctx.$axios({
          url: '/invoice-review/download',
          params: {
            bizId: rootState.biz.id,
            invoiceId: payload.invoiceId
          },
          data: payload,
          method: 'post',
        })
        return data
      },
    }
  }
}

export default module
